import * as React from "react";
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import { SemanticDatepickerProps } from "react-semantic-ui-datepickers/dist/types";

export default function MyDatePicker({
                                         name,
                                         value = null,
                                         onChange = undefined
                                     }: {
    name: string;
    value?: Date | Date[] | null;
    onChange?: (event: React.SyntheticEvent<Element, Event> | undefined, data: SemanticDatepickerProps) => void
}): JSX.Element {

    return (
        <SemanticDatepicker
            pointing="left"
            locale="de-DE"
            format="DD.MM.YYYY"
            name={name}
            value={value}
            onChange={(event, data) => {
                if (onChange !== undefined) {
                    onChange(event, data);
                }
            }}/>
    );
}